import NowakModal from './NowakModel'

var Nowak = new NowakModal()
export default Nowak



// WEBPACK FOOTER //
// ./src/api/Nowak.js